<template>
  <div class="audience-card">
    <div class="audience-card--header">
      <div class="audience-card--header-title">
        <h3 class="primary--text mb-2">{{ audience.name }}</h3>
        <div>{{ audience.timestamp }}</div>
        <div>{{ audience.user }}</div>
      </div>
      <div class="audience-card--header-actions">
        <v-tooltip top>
          <template #activator="{ on }">
            <v-btn
              fab
              outline
              color="primary"
              class="extra-small ma-1"
              :class="{
                'disabled-btn':
                  audience.total_app !== undefined &&
                  audience.total_app.line !== undefined &&
                  audience.total_app.line === 0 &&
                  !audience.total_app.line_exclude
              }"
              v-on="on"
              @click="uploadAudienceToLine()"
            >
              <!-- <v-icon size="18px">send</v-icon> -->
              <i class="fab fa-line"></i>
            </v-btn>
          </template>
          <span>{{ $t('step_message.upload_audience_line') }}</span>
        </v-tooltip>
        <v-tooltip top>
          <template #activator="{ on }">
            <v-btn
              fab
              outline
              color="primary"
              class="extra-small ma-1"
              :class="{
                'disabled-btn':
                  (audience.total_app !== undefined &&
                    audience.total_app.facebook !== undefined &&
                    audience.total_app.facebook === 0) ||
                  !selectedBot.pageid
              }"
              v-on="on"
              @click="uploadAudienceToFb()"
            >
              <!-- <v-icon size="18px">send</v-icon> -->
              <i class="fab fa-facebook"></i>
            </v-btn>
          </template>
          <span>{{ $t('step_message.upload_audience_fb') }}</span>
        </v-tooltip>
        <v-tooltip top>
          <template #activator="{ on }">
            <v-btn
              fab
              outline
              color="primary"
              class="extra-small ma-1"
              v-on="on"
              @click="editAudience"
            >
              <i class="fas fa-pencil-alt"></i>
            </v-btn>
          </template>
          <span>{{ $t('edit') }}</span>
        </v-tooltip>
        <v-tooltip top>
          <template #activator="{ on }">
            <v-btn
              fab
              outline
              color="primary"
              class="extra-small ma-1"
              v-on="on"
              @click="copyAudience()"
            >
              <i class="fa fa-copy middle"></i>
            </v-btn>
          </template>
          <span>{{ $t('copy') }}</span>
        </v-tooltip>
        <v-tooltip top>
          <template #activator="{ on }">
            <v-btn
              fab
              outline
              color="primary"
              class="extra-small ma-1"
              v-on="on"
              @click="deleteAudience()"
            >
              <i class="fa fa-trash middle"></i>
            </v-btn>
          </template>
          <span>{{ $t('Delete') }}</span>
        </v-tooltip>
      </div>
    </div>
    <div class="audience-card--body">
      <div class="audience-card--body-content">
        <div class="d-flex">
          <!-- <div class="d-flex mr-2" style="max-width: 32px; align-items: center">
            <img src="/static/img/assets/line_oa.png" width="32px" alt="line_oa" />
          </div> -->
          <div>
            <div>
              {{ $t('step_message.last_runtime') }} (Facebook) : {{ audience.last_runtime_fb }}
            </div>
            <div>
              {{ $t('step_message.last_runtime') }} (Line) : {{ audience.last_runtime_line }}
            </div>
            <!-- <div>{{ $t('step_message.total_audience') }} : {{ audience.total }}</div> -->
            <div>
              {{ $t('step_message.total_audience') }} :
              <span v-html="audience.total_app_user"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="audience-card--body-more" @click="showAdvanced = !showAdvanced">
        <v-icon color="primary" size="32px">{{
          !showAdvanced ? 'expand_more' : 'expand_less'
        }}</v-icon>
      </div>
    </div>
    <template v-if="showAdvanced">
      <div class="audience-card--detail">
        <div>{{ $t('step_message.add_audience_tag') }}</div>
        <ul class="tags">
          <li
            v-for="(tag, index) in audience.tag_increase_audience"
            :key="'tag_increase_' + index"
            class="tag"
          >
            {{ replaceTags(tag) }}
          </li>
        </ul>

        <div class="mt-2">{{ $t('step_message.remove_audience_tag') }}</div>
        <ul class="tags">
          <li
            v-for="(tag, index) in audience.tag_decrease_audience"
            :key="'tag_decrease_' + index"
            class="tag"
          >
            {{ replaceTags(tag) }}
          </li>
        </ul>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'

import { setTagValue, replaceTags } from '@/utils/tags'
import audienceApi from '@/api/audience'
export default {
  props: {
    value: {
      type: Object
    },
    max: {
      type: Number
    },
    total: {
      type: Number
    }
  },
  data: () => ({
    cachedValue: {},
    showAdvanced: false
  }),
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    }),
    audience() {
      const userName = this.value.last_updated_by || this.value.created_by

      let total = ''
      let apps = []
      const packages = ['facebook', 'line']
      if (this.value.total_app_user && Object.keys(this.value.total_app_user).length) {
        for (const [key, value] of Object.entries(this.value.total_app_user)) {
          if (packages.includes(key)) {
            apps.push(
              `${key.charAt(0).toUpperCase() + key.slice(1)} - ${
                value ? value.toLocaleString() : 0
              }`
            )
          }
        }
      }

      total = apps.join('&nbsp;&nbsp;&nbsp;')

      const addTagComplete =
        this.value && this.value.tag_target_group_add_total_completed_verify_slip
          ? [setTagValue('complete', this.value.tag_target_group_add_total_completed_verify_slip)]
          : []

      const addTagMoreThan =
        this.value && this.value.tag_target_group_add_total_completed_verify_slip_more_than
          ? [
              setTagValue(
                'complete',
                this.value.tag_target_group_add_total_completed_verify_slip_more_than
              )
            ]
          : []

      const removeTagComplete =
        this.value && this.value.tag_target_group_remove_total_completed_verify_slip
          ? [setTagValue('more', this.value.tag_target_group_remove_total_completed_verify_slip)]
          : []

      const removeTagMoreThan =
        this.value && this.value.tag_target_group_remove_total_completed_verify_slip_more_than
          ? [
              setTagValue(
                'more',
                this.value.tag_target_group_remove_total_completed_verify_slip_more_than
              )
            ]
          : []

      return {
        id: this.value.id,
        name: this.value.name,
        timestamp: this.value.last_updated_at
          ? dayjs(this.value.last_updated_at).format('DD/MM/YYYY HH:mm A')
          : dayjs(this.value.created_at).format('DD/MM/YYYY HH:mm A'),
        user: userName,
        last_runtime_fb: this.value.facebook_audience_last_execution_at
          ? dayjs(this.value.facebook_audience_last_execution_at).format('DD/MM/YYYY HH:mm A')
          : '-',
        last_runtime_line: this.value.last_execution_at
          ? dayjs(this.value.last_execution_at).format('DD/MM/YYYY HH:mm A')
          : '-',
        total: this.value.total_user,
        total_app: this.value.total_app_user,
        tag_increase_audience:
          this.value.tag_target_group_add_type === 'all'
            ? [this.$t('All')]
            : [...addTagComplete, ...addTagMoreThan, ...this.value.tag_target_group_add_data],
        tag_decrease_audience:
          this.value.tag_target_group_remove_type === 'all'
            ? [this.$t('All')]
            : this.value.tag_target_group_remove_type === null
            ? [this.$t('None')]
            : [
                ...removeTagComplete,
                ...removeTagMoreThan,
                ...this.value.tag_target_group_remove_data
              ],
        total_app_user: total
      }
    }
  },
  created() {
    dayjs.locale(this.currentLang)
  },
  methods: {
    replaceTags,
    editAudience() {
      this.$emit('edit', this.value.id)
    },
    async uploadAudienceToLine() {
      if (
        !this.audience.total_app ||
        (this.audience.total_app &&
          !this.audience.total_app.line &&
          !this.audience.total_app.line_exclude)
      )
        return
      const isConfirm = await this.$swal.fire({
        title: this.$t('step_message.upload_audience_question'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })
      if (!isConfirm.value) return
      // line_audience_group.audienceGroupId
      try {
        const res = await audienceApi.postLineAudience({
          page_id: this.selectedBot.pageid,
          audience_id: this.value.id
        })
        if (res.status === 200) {
          await this.$swal.fire({
            type: 'success',
            title: this.$t('step_message.upload_audience_success')
          })
          this.$emit('send:success')
        }
      } catch (error) {
        if (error.response && error.response.data.message) {
          let message = ''
          if (
            error.response.data.message &&
            error.response.data.message.includes('unable_to_execute_')
          ) {
            const errMsg = error.response.data.message
              .replaceAll(/\[/g, '')
              .replaceAll(/\]/g, '')
              .split('will_able_to_execute_at_')
            if (errMsg[1]) {
              message = this.$t('step_message.unable_to_proceed', {
                datetime: dayjs(errMsg[1]).format('DD/MM/YYYY HH:mm A')
              })
            }
          } else if (
            error.response.data.message &&
            error.response.data.message.includes('audience_user_is_empty')
          ) {
            message = this.$t('step_message.atlease_1')
          }

          await this.$swal.fire({
            type: 'error',
            title: this.$t('step_message.upload_audience_failed'),
            html: message || JSON.stringify(error.response.data.message)
          })
          return false
        }
        await this.$swal.fire({
          type: 'error',
          title: this.$t('Unsuccessful'),
          text: error.message || ''
        })
        return false
      }
    },
    async uploadAudienceToFb() {
      if (
        !this.audience.total_app ||
        (this.audience.total_app && !this.audience.total_app.facebook)
      )
        return
      const isConfirm = await this.$swal.fire({
        title: this.$t('step_message.upload_audience_question'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })
      if (!isConfirm.value) return
      // line_audience_group.audienceGroupId
      try {
        const res = await audienceApi.postFacebookAudience({
          page_id: this.selectedBot.pageid,
          audience_id: this.value.id
        })
        if (res.status === 200) {
          await this.$swal.fire({
            type: 'success',
            title: this.$t('step_message.upload_audience_success')
          })
          this.$emit('send:success', true)
        }
      } catch (error) {
        if (error.response && error.response.data.message) {
          let message = ''
          if (
            error.response.data.message &&
            error.response.data.message.includes('unable_to_execute_')
          ) {
            const errMsg = error.response.data.message
              .replaceAll(/\[/g, '')
              .replaceAll(/\]/g, '')
              .split('will_able_to_execute_at_')
            if (errMsg[1]) {
              message = this.$t('step_message.unable_to_proceed', {
                datetime: dayjs(errMsg[1]).format('DD/MM/YYYY HH:mm A')
              })
            }
          } else if (
            error.response.data.message &&
            error.response.data.data &&
            error.response.data.data.error &&
            error.response.data.data.error.error_user_title &&
            error.response.data.message === 'unable_to_create_facebook_audience'
          ) {
            message = error.response.data.data.error.error_user_title
          } else if (
            error.response.data.message &&
            error.response.data.message === 'this_page_is_not_connected_with_facebook_ad_account'
          ) {
            message = this.$t(`step_message.${error.response.data.message}`)
          } else if (error.response.data.result && error.response.data.result.fbtrace_id) {
            message =
              error.response.data.result.error_user_msg ||
              error.response.data.result.message ||
              error.response.data.message
          } else if (error.response.data.message) {
            message = error.response.data.message
          } else {
            message = ''
          }
          // if (res.data.message && res.data.message.includes('unable_to_execute_')) {
          //   const errMsg = res.data.message
          //     .replaceAll(/\[/g, '')
          //     .replaceAll(/\]/g, '')
          //     .split('will_able_to_execute_at_')
          //   if (errMsg[1]) {
          //     message = this.$t('step_message.unable_to_proceed', {
          //       datetime: dayjs(errMsg[1]).format('DD/MM/YYYY HH:mm A'),
          //     })
          //   }
          // } else if (res.data.message && res.data.message.includes('audience_user_is_empty')) {
          //   message = this.$t('step_message.atlease_1')
          // }
          const isGotoSetting = message === this.$t(`step_message.${error.response.data.message}`)

          await this.$swal
            .fire({
              type: 'error',
              title: this.$t('step_message.upload_audience_failed'),
              html: message || JSON.stringify(error.response.data.message),
              confirmButtonText: isGotoSetting
                ? this.$t('step_message.go_to_setting')
                : this.$t('Confirm'),
              showCancelButton: isGotoSetting,
              cancelButtonText: isGotoSetting && this.$t('cancel'),
              reverseButtons: true
            })
            .then((value) => {
              if (!value || value.dismiss || !isGotoSetting) return
              this.$router.push({
                name: 'setting',
                query: {
                  tab: 'socialConnect'
                }
              })
            })
          return false
        }
        await this.$swal.fire({
          type: 'error',
          title: this.$t('Unsuccessful'),
          text: error.message || ''
        })
      }
    },
    async deleteAudience() {
      const isConfirm = await this.$swal.fire({
        title: this.$t('step_message.delete_audience_question', { name: this.value.name }),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })
      if (!isConfirm.value) return

      try {
        const res = await audienceApi.deleteAudience({
          page_id: this.selectedBot.pageid,
          audience_id: this.value.id
        })
        if (res.status === 200) {
          await this.$swal.fire({
            type: 'success',
            title: this.$t('step_message.delete_audience_success', { name: this.value.name })
          })
          this.$emit('delete:success', this.value.id)
        }
      } catch (error) {
        if (error.response && error.response.data.message) {
          await this.$swal.fire({
            type: 'error',
            title: this.$t('step_message.delete_audience_failed'),
            text: JSON.stringify(error.response.data.message)
          })
          return false
        }
        await this.$swal.fire({
          type: 'error',
          title: this.$t('Unsuccessful')
        })
      }
    },
    async copyAudience() {
      if (this.total >= this.max) {
        await this.$swal.fire({
          title: this.$t('Warning!'),
          text: this.$t('step_message.limit_reached'),
          type: 'warning',
          confirmButtonText: this.$t('Confirm'),
          reverseButtons: true
        })
        return
      }

      const isConfirm = await this.$swal.fire({
        title: this.$t('step_message.copy_audience_question', { name: this.value.name }),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })

      if (!isConfirm || isConfirm.dismiss) return

      try {
        const payload = {
          name: this.value.name + '_COPY',
          init_type: this.value.init_type === 'file' ? null : this.value.init_type,
          init_data: this.value.init_type === 'file' ? [] : this.value.init_data,
          init_options: {
            file_name:
              this.value.init_type === 'file' ? '' : this.value.init_options.file_name || '',
            total_completed_verify_slip:
              this.value.init_options && this.value.init_options.total_completed_verify_slip
                ? Number(this.value.init_options.total_completed_verify_slip)
                : undefined,
            total_completed_verify_slip_more_than:
              this.value.init_options &&
              this.value.init_options.total_completed_verify_slip_more_than
                ? Number(this.value.init_options.total_completed_verify_slip_more_than)
                : undefined
          },
          tag_target_group_add_type: this.value.tag_target_group_add_type,
          tag_target_group_add_data: this.value.tag_target_group_add_data,
          tag_target_group_add_total_completed_verify_slip: this.value
            .tag_target_group_add_total_completed_verify_slip
            ? Number(this.value.tag_target_group_add_total_completed_verify_slip)
            : null,
          tag_target_group_add_total_completed_verify_slip_more_than: this.value
            .tag_target_group_add_total_completed_verify_slip_more_than
            ? Number(this.value.tag_target_group_add_total_completed_verify_slip_more_than)
            : null,
          tag_target_group_add_add_tag: this.value.tag_target_group_add_add_tag,
          tag_target_group_add_remove_tag: this.value.tag_target_group_add_remove_tag,
          tag_target_group_remove_type: this.value.tag_target_group_remove_type,
          tag_target_group_remove_data: this.value.tag_target_group_remove_data,
          tag_target_group_remove_total_completed_verify_slip: this.value
            .tag_target_group_remove_total_completed_verify_slip
            ? Number(this.value.tag_target_group_remove_total_completed_verify_slip)
            : null,
          tag_target_group_remove_total_completed_verify_slip_more_than: this.value
            .tag_target_group_remove_total_completed_verify_slip_more_than
            ? Number(this.value.tag_target_group_remove_total_completed_verify_slip_more_than)
            : null,
          tag_target_group_remove_add_tag: this.value.tag_target_group_remove_add_tag,
          tag_target_group_remove_remove_tag: this.value.tag_target_group_remove_remove_tag,
          is_allowed_broadcast: this.value.is_allowed_broadcast,
          is_enabled_auto_upload_line: this.value.is_enabled_auto_upload_line,
          is_enabled_auto_upload_line_step_message:
            this.value.is_enabled_auto_upload_line_step_message,
          is_enabled_auto_upload_facebook: this.value.is_enabled_auto_upload_facebook
        }
        const result = await this.createAudience(payload)
        if (result) {
          this.$emit('copy:success')
        }
      } catch (error) {
        console.log({ error })
      }
    },
    async createAudience(payload) {
      try {
        const res = await audienceApi.postAudience({
          page_id: this.selectedBot.pageid,
          ...payload
        })
        if (res.success) {
          await this.$swal.fire({
            type: 'success',
            title: this.$t('step_message.copy_audience_success', { name: this.value.name })
          })
          return true
        }
      } catch (error) {
        if (error.response && error.response.data.message) {
          await this.$swal.fire({
            type: 'error',
            title: this.$t('step_message.copy_audience_failed'),
            text: JSON.stringify(error.response.data.message)
          })
          return false
        }
        await this.$swal.fire({
          type: 'error',
          title: this.$t('Unsuccessful')
        })
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.audience-card {
  display: flex;
  flex-direction: column;
  width: 100%;
  border: 1px solid var(--primary-color);
  border-radius: 15px;
  -o-border-radius: 15px;
  -ms-border-radius: 15px;

  .audience-card--header {
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 16px;
    .audience-card--header-title {
      display: block;
      flex: 1 1 0;
    }
    .audience-card--header-actions {
      display: flex;
      align-items: flex-start;
      width: fit-content;
      column-gap: 2px;
    }
  }

  .audience-card--body {
    display: flex;
    justify-content: space-between;
    padding: 0 16px 16px;

    .audience-card--body-content {
      .audience-card--header-title {
        display: block;
      }
    }

    .audience-card--body-more {
      width: fit-content;
      cursor: pointer;
    }
  }

  .audience-card--detail {
    display: block;
    width: 100%;
    padding: 16px;
    border-top: 1px solid #cec8c8;
  }

  .disabled-btn {
    color: rgba(0, 0, 0, 0.26) !important;
    cursor: not-allowed;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/stepmessage/AudienceCard.vue